import { services as customer } from './customer'
import { services as plan } from './plan'

export default {
    ...customer,
    ...plan
}